// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1fj3S","content":"styles_content__19oZQ","checkbox":"styles_checkbox__2GhGX","checkboxLabel":"styles_checkboxLabel__3LS_l"};